export function isInAppBrowser() {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent || navigator.vendor || "";
  return /Instagram|FBAN|FBAV|FB_IAB|Line\/|MicroMessenger|TikTok/i.test(ua);
}

export function isAndroid() {
  if (typeof navigator === "undefined") return false;
  return /Android/i.test(navigator.userAgent || "");
}

export function isIOS() {
  if (typeof navigator === "undefined") return false;
  return /iPhone|iPad|iPod/i.test(navigator.userAgent || "");
}

export function buildAndroidChromeIntentUrl() {
  const loc = window.location;
  const rest = `${loc.host}${loc.pathname}${loc.search}`;
  const fallback = encodeURIComponent(loc.href);
  return `intent://${rest}#Intent;scheme=https;package=com.android.chrome;S.browser_fallback_url=${fallback};end;`;
}
